import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { onMounted, ref, watch } from "vue";
import { CloseCircleOutlined } from "@ant-design/icons-vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollNoitce',
  props: {
  content: {
    type: String,
    default: "",
  },
  color: {
    type: String,
    default: "#FF7D00",
  },
  fontSize: {
    type: Number,
    default: 14,
  },
  speed: {
    type: Number,
    default: 0,
  },
  bgColor: {
    type: String,
    default: "#FFF7E8",
  },
  height: {
    type: Number,
    default: 40,
  },
},
  emits: ["closeScrollNotice"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

/**
 * ScrollNoitce 公告栏跑马灯
 * @description 从右往左的跑马灯
 * @property {String} content 显示的内容，支持html
 * @property {String} color 文字颜色，默认#FF7D00
 * @property {Number} fontSize 文字大小，默认14
 * @property {Number} speed 滚动速度，单位s（播放一次所用时间，默认根据内容宽度计算时间）
 * @property {String} bgColor 背景颜色，默认#FFF7E8
 * @property {Number} height 背景高度，默认40
 */
const props = __props;
const DEFAULT_SPEED = ref(143);
const title = ref("");
const speed = ref(0);
const marqueeTitle = ref(null);
watch(
  () => props.content,
  (val) => {
    if (val) title.value = val;
    calcSpeed();
  },
  { deep: true }
);
watch(
  () => props.speed,
  (val) => {
    speed.value = val;
  }
);
const calcSpeed = () => {
  if (title.value !== "" && props.speed === 0) {
    let width = (marqueeTitle.value! as Element).clientWidth;
    speed.value = +Number(width / DEFAULT_SPEED.value).toFixed(2);
  }
};
onMounted(() => {
  if (props.content) title.value = props.content;
  if(props.speed) speed.value = props.speed;
  calcSpeed();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "marquee",
    style: _normalizeStyle({ backgroundColor: props.bgColor, height: props.height + 'px' })
  }, [
    _createElementVNode("span", {
      class: "marquee__title",
      ref_key: "marqueeTitle",
      ref: marqueeTitle,
      style: _normalizeStyle({ color: props.color, fontSize: props.fontSize + 'px', animationDuration: speed.value + 's', '--speed': speed.value }),
      innerHTML: title.value
    }, null, 12, _hoisted_1),
    _createTextVNode(" " + _toDisplayString(title.value) + " " + _toDisplayString(props.content) + " ", 1),
    _createVNode(_unref(CloseCircleOutlined), {
      class: "marquee__close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeScrollNotice')))
    })
  ], 4))
}
}

})